import { EventEmitter, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HalApiCaller } from '@dxc-technology/halstack-client';
import { DialogMessageComponent } from '../shared/dialog-message/dialog-message.component';
import { MatDialog } from '@angular/material/dialog';
import jwt_decode from 'jwt-decode';
import { ConfirmationDialogComponent } from '../shared/confirmation-dialog/confirmation-dialog.component';
import { BehaviorSubject } from 'rxjs';
let en = require('../../assets/i18n/en_help.json');
let ar = require('../../assets/i18n/ar_help.json');

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  updateQueueDashboard: EventEmitter<any> = new EventEmitter();
  activateClaimCard: EventEmitter<any> = new EventEmitter();
  activateAssessmentCard: EventEmitter<any> = new EventEmitter();
  activateLoadingHomePage: EventEmitter<any> = new EventEmitter();
  activateBusinessDate: EventEmitter<any> = new EventEmitter();
  activateLifes: EventEmitter<any> = new EventEmitter();
  validationAssessment: EventEmitter<any> = new EventEmitter();
  approveAssessorRemark: EventEmitter<any> = new EventEmitter();
  nextAssessorRemark: EventEmitter<any> = new EventEmitter();
  navigateAssessment: EventEmitter<any> = new EventEmitter();
  rerouteInvestigation: EventEmitter<any> = new EventEmitter();
  dateformets: any = environment.DATE_FORMAT.toLowerCase();
  headers = {};
  Requirements: any;
  positionBeforeDisability;
  positionAfterDisability;
  assessorRemarksCompleted: any;
  uuidLifeAssured: any;
  lazyList: any = {};
  claimRequirementList: any;
  beneficiaryListDetails: any;
  investigationDataList: any;
  claimStatusCheck: any;
  claimReviewPolicyDetails = {};
  contractCurrencyPaymentList = [];
  policyList;
  productList: any = {};
  createClaimsFollowUp: { [unit: string]: any } = {
    model: {
      uuid: '',
      code: '',
      status: '',
      description: '',
      createdBy: '',
      createdOn: '',
      nextReminderDate: '',
      reportDays: '',
      doctorIndicator: '',
      value: '',
      label: ''
    },
  };
  additionalMedicalDropDownData: any;
  additionalQuestionarriesDropDownData: any;
  routingLink;
  tokenInfo;
  userInfo;
  userName;
  userData;
  language: any;
  lifeLookupList
  analyseDropDownData: any;
  Active_Profile = environment.ENV_ACTIVE_PROFILE;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_PREMISES = environment.ON_PREMISES;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  userdetails
  dropDownData
  private spinnerMesage = new BehaviorSubject(false);
  currentSpinnerMessage = this.spinnerMesage.asObservable();
  private helpIcon = new BehaviorSubject(false);
  showHelpIcon = this.helpIcon.asObservable();
  private languagelist = new BehaviorSubject([]);
  dynamicLanguage = this.languagelist.asObservable();
  private updatelanguage = new BehaviorSubject(false);
  languagechnage = this.updatelanguage.asObservable();
  private successMesage = new BehaviorSubject({
    isVisible: false,
    message: "",
    showbutton: false,
    uuid: ''
  });
  currentSuccessMessage = this.successMesage.asObservable();
  lookupList
  folowuplist = 'clientIdTypes,Country,Gender,RelationshipProposer,MaritalStatus,Nationality,countryCodes,FraudAnamoliesStatus';
  dropDownDataManageappointment;
  paymentByBeneficiaryList: any;

  adjustedReasonModel = { longDesc: '', reasonCode: '' };
  adjustReasonCode: '';
  adjustmentLongDesc: '';
  adjustmentLongDescFree: '';
  claimNotesEnquiry: { notifinum: any, notes: any, datime: any }[] = [];
  isSaveClaimNotes: boolean = false;

  adjustFlag: boolean = false;
  profileIdArr: any = [];
  userNameArr: any = [];
  eligibleUsersList: any = [];
  bankPaymentDetails: any = [];
  dailyLivingDetails: any = [];

  constructor(private dialog: MatDialog) {
    this.headers = this.getHeaders();
  }
  changespinnerMessage(message: any) {
    this.spinnerMesage.next(message)
  }
  dynamicLanguagelist(message: any) {
    this.languagelist.next(message)
  }
  showHelpIocn(message: any) {
    this.helpIcon.next(message)
  }
  changeSuccessMessage(message: any) {
    this.successMesage.next(message)
  }
  updatehelpjson(message: any) {
    this.updatelanguage.next(message)
  }

  getHeaders() {
    let userrole=localStorage.getItem('userRole')
    let buttonEnable = 'N';
    if (this.userdetails) {
      if (this.userdetails.businessDateEnable == 'Yes') {
        buttonEnable = 'Y';
      }
    }
    const commonHeaders = {
      authorization: 'Bearer ' + localStorage.getItem('access_token'),
      username: localStorage.getItem('userName')!= undefined&&localStorage.getItem('userName')!=null?localStorage.getItem('userName'):'',
      createUser:localStorage.getItem('userName')!= undefined&&localStorage.getItem('userName')!=null?localStorage.getItem('userName'):'',
      country:localStorage.getItem('regionSelected')!= undefined&&localStorage.getItem('regionSelected')!=null?localStorage.getItem('regionSelected'):'',
      language:localStorage.getItem('language')!= undefined&&localStorage.getItem('language')!=null?localStorage.getItem('language'):'',
      businessdateenable: buttonEnable,
      lob: userrole != undefined && userrole != null ? userrole.replace(userrole=='L_CO'||userrole=='C_L_CO'?'_CO':'_CF', '') : ''
    };
    // Cloud
    if (this.ON_CLOUD === this.PROFILE) {
        commonHeaders['x-api-key'] = environment.COGNITO.x_api_key
    }
    return commonHeaders;
  }

  //get Token and  Token_Info
  get_tokenInfo() {
    let token;
    if (this.Active_Profile == this.ON_PREMISES) {
      token = sessionStorage.getItem('id_token');
      this.tokenInfo = jwt_decode(token);
      localStorage.setItem('access_token', token);
      localStorage.setItem('userName', this.tokenInfo.preferred_username);
      localStorage.setItem('clientNumber', this.tokenInfo.clientNumber);
      localStorage.setItem('firstName', this.tokenInfo.firstName);
      localStorage.setItem('lastName', this.tokenInfo.lastName);
    }
    // Congito environment
    else if (this.Active_Profile == this.ON_CLOUD) {
      token = sessionStorage.getItem('id_token');
      this.tokenInfo = jwt_decode(token);
    }
    // CAS environment
    else if (this.Active_Profile == this.ON_PREMISES_CAS) {
      token = localStorage.getItem('access_token');
      this.tokenInfo = jwt_decode(token);
      localStorage.setItem('userName', this.tokenInfo.sub);
    }
    return this.tokenInfo;
  }
  //get user info
  async getUserInfo() {
    this.userName = localStorage.getItem('userName');
    let res = await HalApiCaller.get({
      url:
        environment.API_SERVER_URL + '/userinfo?userName=' + `${this.userName}`,
      headers: this.getHeaders(),
    });
    this.userInfo = res;
    localStorage.setItem('clientNumber', this.userInfo.body.clientNumber);
    return this.userInfo;
  }
  showNotifyMessage(message, status, timeout, detailsMsg?) {
    if (message != undefined) {
      timeout = timeout || 5000;
      let colorBG;
      let colorText;
      let icon;
      if (status == 'success') {
        status = 'success';
        colorBG = { background: '#5f249f' };
        colorText = { color: '#ffffff' };
        icon = 'success';
      } else if (status == 'error') {
        status = 'error';
        colorBG = { background: '#980115' };
        colorText = { color: '#dc3545' };
        icon = 'error';
      } else if (status == 'successmessage') {
        status = 'successmessage';
        colorBG = { background: '#5f249f' };
        colorText = { color: '#ffffff' };
        icon = 'success';
      } else if (status == 'errorAndReason') {
        status = 'errorAndReason';
        colorBG = { background: '#980115' };
        colorText = { color: '#dc3545' };
        icon = 'error';
      }

      this.dialog.open(DialogMessageComponent, {
        disableClose: true,
        data: {
          message: message,
          reasonError: detailsMsg,
          status: status,
          colorBG: colorBG,
          colorText: colorText,
          icon: icon,
        },
        minWidth: '100vw',
        position: {
          bottom: '0%',
        },
        minHeight: '100px',
        backdropClass: 'notificationDialog',
      });
    }
    window.setTimeout(() => {
      this.dialog.closeAll();
    }, timeout);
  }
  showNotifyMessagesend(message, status) {
    if (message != undefined) {
      let colorBG;
      let colorText;
      let icon;
      if (status == 'customerSurvey') {
        status = 'customerSurvey';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'error') {
        status = 'error';
        colorBG = { background: '#dc3545', height: '3rem' };
        colorText = { color: '#dc3545', height: '3rem' };
        icon = 'error';
      } else if (status == 'success') {
        status = 'success';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'confirmStatus') {
        status = 'confirmStatus';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'confirmStatus';
      }

      this.dialog.open(DialogMessageComponent, {
        disableClose: true,
        data: {
          message: message,
          status: status,
          colorBG: colorBG,
          colorText: colorText,
          icon: icon,
        },
        width: '400px',
        position: {
          // bottom: '10px',
          top: '15%',
          left: '35%',
        },
        minHeight: '200px',
      });
    }
  }

  //manage appointment time slot
  time_slot_dropdown: Array<any> = [
    { value: '8:00 AM - 8:30 AM', label: '8:00 AM - 8:30 AM' },
    { value: '8:30 AM - 9:00 AM', label: '8:30 AM - 9:00 AM' },
    { value: '9:00 AM - 9:30 AM', label: '9:00 AM - 9:30 AM' },
    { value: '9:30 AM - 10:00 AM', label: '9:30 AM - 10:00 AM' },
    { value: '10:00 AM - 10:30 AM', label: '10:00 AM - 10:30 AM' },
    { value: '10:30 AM - 11:00 AM', label: '10:30 AM - 11:00 AM' },
    { value: '11:00 AM - 11:30 AM', label: '11:00 AM - 11:30 AM' },
    { value: '11:30 AM - 12:00 PM', label: '11:30 AM - 12:00 PM' },
    { value: '12:00 PM - 12:30 PM', label: '12:00 PM - 12:30 PM' },
    { value: '12:30 PM - 1:00 PM', label: '12:30 PM - 1:00 PM' },
    { value: '1:00 PM - 1:30 PM', label: '12:30 PM - 1:00 PM' },
    { value: '1:30 PM - 2:00 PM', label: '1:30 PM - 2:00 PM' },
    { value: '2:00 PM - 2:30 PM', label: '2:00 PM - 2:30 PM' },
    { value: '2:30 PM - 3:00 PM', label: '2:30 PM - 3:00 PM' },
    { value: '3:00 PM - 3:30 PM', label: '3:00 PM - 3:30 PM' },
    { value: '3:30 PM - 4:00 PM', label: '3:30 PM - 4:00 PM' },
    { value: '4:00 PM - 4:30 PM', label: '4:00 PM - 4:30 PM' },
    { value: '4:30 PM - 5:00 PM', label: '4:30 PM - 5:00 PM' },
    { value: '5:00 PM - 5:30 PM', label: '5:00 PM - 5:30 PM' },
    { value: '5:30 PM - 6:00 PM', label: '5:30 PM - 6:00 PM' },
    { value: '6:00 PM - 6:30 PM', label: '6:00 PM - 6:30 PM' },
    { value: '6:30 PM - 7:00 PM', label: '6:30 PM - 7:00 PM' },
    { value: '7:00 PM - 7:30 PM', label: '7:00 PM - 7:30 PM' },
    { value: '7:30 PM - 8:00 PM', label: '7:30 PM - 8:00 PM' },
  ];

  finalDecisionPopUp(message, status) {
    if (message != undefined) {
      let colorBG;
      let colorText;
      let icon;

      this.dialog.open(DialogMessageComponent, {
        disableClose: true,
        data: {
          message: message,
          status: status,
          colorBG: colorBG,
          colorText: colorText,
          icon: icon,
          component: 'finalDecision',
        },
        width: '400px',
        position: {
          // bottom: '10px',
          top: '15%',
          left: '35%',
        },
        minHeight: '200px',
      });
    }
  }

  showConfirmationDialog(action, message, leftBtn, rightBtn) {
    let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        action: action,
        message: message,
        status: 'Confirm',
        leftBtn: leftBtn,
        rightBtn: rightBtn,
      },
      width: '400px',
      minHeight: '250px',
      autoFocus: true,
      // position: {
      // 	bottom: '0px'
      // 	},
      id: 'showYesDialog',
    });
    return dialogRef.afterClosed();
  }
  intialDropdownModel: { [unit: string]: any } = {
    params: 'followUpStatusCodes',
  };
  Currency = [
    {
      id: 1,
      countryCode: 'SGD',
      symbol: '$',
    },
    {
      id: 2,
      countryCode: 'INR',
      symbol: '₹',
    },
    {
      id: 3,
      countryCode: 'GBP',
      symbol: '£',
    },
  ];
  furtherUnderWriting = [
    {
      id: 1,
      Serialno: '1',
      MedicalRequirements: 'BEX ',
      DescriptionsofRequirements: 'Blood Examination',
      status: 'pending',
    },

  ];
  AnalyseReport = [
    {
      name: '35, Male, Married',
      dob: '02/10/997',
      Race: 'American',
      Tobacco: 'No',
      bmi: '27.4',
      id: 'S223123',
      idType: 'Passport',
    },
  ];
  analyseData = [
    {
      id: 1,
      Serialno: '1',
      MedicalRequirements: 'BEX ',
      DescriptionsofRequirements: 'Blood Examination',
      status: 'pending',
    },
    {
      id: 2,
      Serialno: '2',
      MedicalRequirements: 'APS',
      DescriptionsofRequirements: 'Attending Physician Statements',
      status: 'Received',
    },
  ];
  othersData = [
    {
      id: 1,
      Serialno: '1',
      MedicalRequirements: 'BEX ',
      DescriptionsofRequirements: 'Blood Examination',
      status: 'pending',
    },
    {
      id: 2,
      Serialno: '2',
      MedicalRequirements: 'APS',
      DescriptionsofRequirements: 'Attending Physician Statements',
      status: 'Received',
    },
  ];
  QuestionariesData = [
    {
      id: 1,
      Serialno: '1',
      MedicalRequirements: 'BEX ',
      DescriptionsofRequirements: 'Blood Examination',
      status: 'pending',
    },
    {
      id: 2,
      Serialno: '2',
      MedicalRequirements: 'APS',
      DescriptionsofRequirements: 'Attending Physician Statements',
      status: 'Received',
    },
  ];
  requirements = [
    {
      name: '35, Male, Married',
      dob: '02/10/997',
      Race: 'American',
      Tobacco: 'No',
      bmi: '27.4',
      id: 'S223123',
      idType: 'Passport',
    },
  ];

  casereview = [
    {
      id: 1,
      policynumber: '24129832',
      inception: '20/09/2021',
      issuance: '24/09/2021',
      coverage: 'Endowment DB',
      rider: '-',
      status: 'Proposal',
      sum: '$100000',
      premium: '$2000',
    },
    {
      id: 2,
      policynumber: '',
      inception: '',
      issuance: '',
      coverage: '',
      rider: 'Critical Illness',
      status: 'Proposal',
      sum: '$25000',
      premium: '$1200',
    },
    {
      id: 3,
      policynumber: '',
      inception: '',
      issuance: '',
      coverage: '',
      rider: 'Waiver',
      status: 'Proposal',
      sum: '$2400',
      premium: '$200',
    },
  ];
  questionarie = [
    {
      id: 1,
      question1: 'yes',
      question2: 'No',
      question3: 'yes',
      question4: 'yes',
      question5: 'No',
    },
  ];
  existingpolicies = [
    {
      id: 1,
      policynumber: '24129832',
      inception: '20/09/2021',
      issuance: '24/09/2021',
      coverage: 'Endowment DB',
      rider: '-',
      status: 'In-Force',
      sum: '$100000',
      premium: '$2000',
    },
    {
      id: 2,
      policynumber: '',
      inception: '',
      issuance: '',
      coverage: '',
      rider: 'Critical Illness',
      status: 'In-Force',
      sum: '$25000',
      premium: '$200',
    },
    {
      id: 3,
      policynumber: '',
      inception: '',
      issuance: '',
      coverage: '',
      rider: 'Waiver',
      status: 'In-Force',
      sum: '$2400',
      premium: '$200',
    },
    {
      id: 4,
      policynumber: '24129832',
      inception: '20/09/2021',
      issuance: '24/09/2021',
      coverage: 'Term Insurance',
      rider: '-',
      status: 'In Force',
      sum: '$100000',
      premium: '$2000',
    },
    {
      id: 5,
      policynumber: '',
      inception: '',
      issuance: '',
      coverage: '',
      rider: 'Accidental Death Benefit',
      status: 'In-Force',
      sum: '$25000',
      premium: '$1200',
    },
    {
      id: 6,
      policynumber: '',
      inception: '',
      issuance: '',
      coverage: '',
      rider: 'Total Permanent Disability',
      status: 'In-Force',
      sum: '$2400',
      premium: '$200',
    },
  ];
  familyhistory = [
    {
      id: 1,
      relation: 'Father',
      age: '65',
      diabetes: 'Tick',
      hypertension: 'Tick',
      heart: 'Wrong',
      tumor: 'Wrong',
      healthcondition: 'Not Good',
    },
    {
      id: 2,
      relation: 'Mother',
      age: '56',
      diabetes: 'Wrong',
      hypertension: 'Wrong',
      heart: 'Wrong',
      tumor: 'Wrong',
      healthcondition: 'Normal',
    },
    {
      id: 3,
      relation: 'Sibling1',
      age: '34',
      diabetes: 'Wrong',
      hypertension: 'Wrong',
      heart: 'Wrong',
      tumor: 'Wrong',
      healthcondition: 'Good',
    },
    {
      id: 4,
      relation: 'Sibling 2',
      age: '30',
      diabetes: 'Wrong',
      hypertension: 'Wrong',
      heart: 'Wrong',
      tumor: 'Wrong',
      healthcondition: 'Good',
    },
    {
      id: 5,
      relation: 'Sibling 3',
      age: '28',
      diabetes: 'Wrong',
      hypertension: 'Wrong',
      heart: 'Wrong',
      tumor: 'Wrong',
      healthcondition: 'Good',
    },
    {
      id: 6,
      relation: 'Sibling 4',
      age: '22',
      diabetes: 'Wrong',
      hypertension: 'Wrong',
      heart: 'Wrong',
      tumor: 'Wrong',
      healthcondition: 'data',
    },
  ];
  checkAlter = [
    {
      id: 1,
      coverage: 'Death Benefit',
      sumAssured: '$100,000',
      premium: '$1074.00',
      occupation: 'Accepted',
      medical: 'Accepted',
      residential: 'Accepted',
      lifestyle: 'Accepted',
    },
    {
      id: 2,
      coverage: 'Critical Illness',
      sumAssured: '$50,000',
      premium: '$250.00',
      occupation: 'Accepted',
      medical: 'Accepted',
      residential: 'NA',
      lifestyle: 'NA',
    },
    {
      id: 3,
      coverage: 'Total Permanent Disability',
      sumAssured: '$100,000',
      premium: '$196.00',
      occupation: 'Accepted',
      medical: 'Accepted',
      residential: 'NA',
      lifestyle: 'NA',
    },
    {
      id: 4,
      coverage: 'Waiver',
      sumAssured: '$1520',
      premium: '$30.00',
      occupation: 'Accepted',
      medical: 'Accepted',
      residential: 'Accepted',
      lifestyle: 'Accepted',
    },
  ];
  reviewCounter = [
    {
      id: 1,
      rider: '',
      coverage: 'Death Benefit',
      sumAssured: '$100,000',
      premium: '$1074.00',
      loadingPremium: '-',
      medical: '1074.00',
    },
    {
      id: 2,
      rider: '02. Total premium  Disablity',
      coverage: 'Critical Illness',
      sumAssured: '$50,000',
      premium: '$250.00',
      loadingPremium: '$100.00',
      medical: '$350.00',
    },
    {
      id: 3,
      rider: '03. Waiver',
      coverage: 'Total Permanent Disability',
      sumAssured: '$100,000',
      premium: '$196.00',
      loadingPremium: '$66.00',
      medical: '$262.00',
    },
    {
      id: 4,
      rider: '03. Waiver',
      coverage: 'Waiver',
      sumAssured: '$1550',
      premium: '$30.00',
      loadingPremium: '$3.21',
      medical: '$33.21',
    },
  ];
  applyLoading = [
    {
      id: 1,
      coverage: 'Death Benefit',
      sumAssured: '$100,000',
      premium: '$1074.00',
      rateAdjustment: '-',
      loadSA: '-',
      premiumLoading: '-',
      ageRating: '-',
      flatMortality: '-',
    },
    {
      id: 2,
      coverage: 'Critical Illness',
      sumAssured: '$50,000',
      premium: '$250.00',
      rateAdjustment: '-',
      loadSA: '-',
      premiumLoading: '-',
      ageRating: '-',
      flatMortality: '-',
    },
    {
      id: 3,
      coverage: 'Total Permanent Disability',
      sumAssured: '$100,000',
      premium: '$196.00',
      rateAdjustment: '2',
      loadSA: '-',
      premiumLoading: '-',
      ageRating: '5',
      flatMortality: '-',
    },
    {
      id: 4,
      coverage: 'Waiver',
      sumAssured: '$1520',
      premium: '$30.00',
      rateAdjustment: '-',
      loadSA: '-',
      premiumLoading: '-',
      ageRating: '-',
      flatMortality: '200',
    },
  ];
  premLoading = [
    {
      id: 1,
      coverage: 'Death Benefit',
      sumAssured: '$100,000',
      premium: '$1074.00',
      rateAdjustment: '-',
      loadSA: '-',
      premiumLoading: '-',
      ageRating: '-',
      flatMortality: '-',
      flatmortality: '-',
    },
    {
      id: 2,
      coverage: 'Critical Illness',
      sumAssured: '$50,000',
      premium: '$250.00',
      rateAdjustment: '$100.00',
      loadSA: '-',
      premiumLoading: '-',
      ageRating: '-',
      flatMortality: '-',
      flatmortality: '$100.00',
    },
    {
      id: 3,
      coverage: 'Total Permanent Disability',
      sumAssured: '$100,000',
      premium: '$196.00',
      rateAdjustment: '-',
      loadSA: '-',
      premiumLoading: '-',
      ageRating: '$22.00',
      flatMortality: '$44.00',
      flatmortality: '$66.00',
    },
    {
      id: 4,
      coverage: 'Waiver',
      sumAssured: '$1520',
      premium: '$30.00',
      rateAdjustment: '$1.93',
      loadSA: '-',
      premiumLoading: '-',
      ageRating: '$0.43',
      flatMortality: '$0.85',
      flatmortality: '$3.21',
    },
  ];
  Questionairedata = [
    {
      id: 1,
      Serialno: '1',
      MedicalRequirements: 'AVO ',
      DescriptionsofRequirements: 'Avocations',
      status: 'Manually Added',
    },
    {
      id: 2,
      Serialno: '2',
      MedicalRequirements: 'FQU',
      DescriptionsofRequirements: 'Financial Underwriting Questionnaire',
      status: 'Manually Added',
    },
  ];

  sizeof = [
    {
      id: 1,
      Serialno: '1',
      MedicalRequirements: 'BEX ',
      DescriptionsofRequirements: 'Blood Examination',
      status: 'Auto Added',
    },
    {
      id: 2,
      Serialno: '2',
      MedicalRequirements: 'APS ',
      DescriptionsofRequirements: 'Attending Physician Status',
      status: 'Auto Added',
    },
    {
      id: 3,
      Serialno: '3',
      MedicalRequirements: 'Hb1ac ',
      DescriptionsofRequirements: 'Hb1ac-Haemoglobin-ac',
      status: 'manually Added',
    },
    {
      id: 4,
      Serialno: '4',
      MedicalRequirements: 'EEG ',
      DescriptionsofRequirements: 'Electro Encephalo Graph',
      status: 'Auto Added',
    },
    {
      id: 5,
      Serialno: '5',
      MedicalRequirements: 'CMR ',
      DescriptionsofRequirements: 'Cancer Marker',
      status: 'Auto Added',
    },
  ];

  sizeof02 = [
    {
      id: 6,
      Serialno: '6',
      MedicalRequirements: 'ECG ',
      DescriptionsofRequirements: 'ELectro Cardiogram',
      status: 'Auto Added',
    },
  ];
  nonmedical = [
    {
      id: 1,
      Serialno: '1',
      MedicalRequirements: 'BEX ',
      DescriptionsofRequirements: 'Blood Examination',
      status: 'Auto Added',
    },
    {
      id: 2,
      Serialno: '2',
      MedicalRequirements: 'APS ',
      DescriptionsofRequirements: 'Attending Physician Status',
      status: 'Auto Added',
    },
    {
      id: 3,
      Serialno: '3',
      MedicalRequirements: 'Hb1ac ',
      DescriptionsofRequirements: 'Hb1ac-Haemoglobin-ac',
      status: 'Manually Added',
    },
    {
      id: 4,
      Serialno: '4',
      MedicalRequirements: 'EEG ',
      DescriptionsofRequirements: 'Electro Encephalo Graph',
      status: 'Auto Added',
    },
    {
      id: 5,
      Serialno: '5',
      MedicalRequirements: 'CMR ',
      DescriptionsofRequirements: 'Cancer Marker',
      status: 'Auto Added',
    },
    {
      id: 6,
      Serialno: '6',
      MedicalRequirements: 'ECG ',
      DescriptionsofRequirements: 'ELectro Cardiogram',
      status: 'Auto Added',
    },
  ];
  nonmedical02 = [
    {
      id: 7,
      Serialno: '7',
      MedicalRequirements: 'FIQ',
      DescriptionsofRequirements: 'Financial Questionnaire',
      status: 'Manually Added',
    },
    {
      id: 8,
      Serialno: '8',
      MedicalRequirements: 'ELT',
      DescriptionsofRequirements: 'Employment Letter',
      status: 'Manually Added',
    },
  ];
  bmidata = [
    {
      id: 1,
      Serialno: '1',
      MedicalRequirements: 'LQU ',
      DescriptionsofRequirements: 'Lifestyle Questionnaire',
      status: 'Auto Added',
    },
    {
      id: 2,
      Serialno: '2',
      MedicalRequirements: 'APS ',
      DescriptionsofRequirements: 'Attending Physician Status',
      status: 'Auto Added',
    },
    {
      id: 3,
      Serialno: '3',
      MedicalRequirements: 'Hb1ac ',
      DescriptionsofRequirements: 'Hb1ac-Haemoglobin-ac',
      status: 'manually Added',
    },
  ];



  //get Followup dropdow API

  async getadditionalMedicalDropdownList(policyNum) {
    let res = await HalApiCaller.get({
      url:
        environment.API_SERVER_URL +
        // '/medicalrequirements/medicalFollowUp/1001',
        `/medicalrequirements/medicalFollowUp/${policyNum}`,

      //?doctorRequired=Y

      headers: this.getHeaders(),
    });

    this.additionalMedicalDropDownData = res.body;

    return this.additionalMedicalDropDownData;
  }

  async getadditionalQuestionarriesList() {
    let res = await HalApiCaller.get({
      url:
        environment.API_SERVER_URL +
        '/medicalrequirements/medicalFollowUp/1001',

      //?doctorRequired=Y

      headers: this.getHeaders(),
    });

    this.additionalQuestionarriesDropDownData = res.body;

    return this.additionalQuestionarriesDropDownData;
  }

  //get adminSettings dropdow API
  async getAllConfigDropdownList(type) {
    try {
      let url = environment.API_CONFIG_URL + `configuration/lookup?list=${type}`;
      let dropDownResponse = await this.commonGet(url);
      this.lazyList = { ...this.lazyList, ...dropDownResponse.body };
    } catch (err) {
      console.log('Get API Error - Claim Data', err);
    }
    return this.analyseDropDownData;
  }
    //get all dropdow API
    async getAllDropdownList() {
      try {
        let res = await HalApiCaller.get({
          url:
            environment.API_LOOK_UP +
            '?list=language_Setup',
          headers: this.getHeaders(),
        });
        if (
          res.status !== undefined &&
          (res.status === 200 || res.status === 201)
        ) {
          this.dropDownData = res.body;
          return this.dropDownData;
        }
      } catch (error) {
      }
    }
    async getAllLifeLookUp() {
      try {
        let res = await HalApiCaller.get({
          url:
            environment.API_CONFIG_URL +
            'configuration/lookup?list=FraudAnamoliesStatus',
          headers: this.getHeaders(),
        });
        if (
          res.status !== undefined &&
          (res.status === 200 || res.status === 201)
        ) {
          this.lifeLookupList = res.body;
          return this.dropDownData;
        }
      } catch (error) {
      }
    }
  dataisemity(data) {
    if (data) {
      return data;
    } else {
      return '-'
    }
  }
  amountisEmity(data) {
    if (data) {
      return ' ' + data
    } else {
      return 0
    }
  }
  dataformet(date) {
    if (date) {
      if (date.indexOf("-") != 2) {
        return date.split("-").reverse().join("/")
      }
      else {
        return date.split("-").join("/")
      }
    } else {
      return '-'
    }
  }
  findkeyLabel(item: any, type: string) {
    let label = ''
    this.lookupList[type].map(data => {
      if (data.value == item || item.toUpperCase() == data.label.toUpperCase()) {
        label = data.label;
      }
    })
    return label
  }
  // all look list 
  async getAllLookupList() {
    try {
      let url = environment.API_CONFIG_COMMON + `lookup?list=${this.folowuplist}`;
      let dropDownResponse = await this.commonGet(url);
      this.lazyList = dropDownResponse.body;
    } catch (err) {
      console.log('Get API Error - Claim Data', err);
    }
  }
  async getLanguageLookup() {
    let res = await HalApiCaller.get({
      url: environment.API_CONFIG_COMMON + `lookup/enum?list=country_language`,
      headers: this.getHeaders(),
    });
    return res.body;
  }
  //Method GET
  async commonGet(url, headers?) {
    try {
      let response = await HalApiCaller.get({
        url,
        headers: this.getHeaders(),
      });
      return response;
    } catch (err) {
      return err.response;
    }
  }
  //Method POST
  async commonPost(url, body, headers?) {
    try {
      let response = await HalApiCaller.post({
        url: url,
        body,
        headers: this.getHeaders(),
      });
      return response;
    } catch (err) {
      return err.response;
    }
  }

  //Method PATCH
  async commonPatch(url, body, headers?) {
    try {
      let response = await HalApiCaller.patch({
        url: url,
        body,
        headers: this.getHeaders(),
      });
      return response;
    } catch (err) {
      return err.response;
    }
  }

  //Method DELETE
  async commonDelete(url, headers?) {
    try {
      let response = await HalApiCaller.del({
        url: url,
        headers: this.getHeaders(),
      });
      return response;
    } catch (err) {
      return err.response;
    }
  }
  async updateClaimOfficedate(body) {
    let header = this.getHeaders();
    header['username'] = localStorage.getItem('userName');
    let res = await HalApiCaller.patch({
      url: environment.API_CLAIM_OFFICE_SERVER_URL + `modifyBusinessDate`,
      headers: header,
      // headers: this.getHeaders(),
      body: body,
    });
    return res.body;
  }
  async getClaimOfficeDate() {
    let buttonEnable = 'N';
    if (this.userdetails) {
      if (this.userdetails.businessDateEnable == 'Yes') {
        buttonEnable = 'Y';
      }
    }
    let header = this.getHeaders();
    header['username'] = localStorage.getItem('userName');
    header['businessdateenable'] = buttonEnable
    let res = await HalApiCaller.get({
      url: environment.API_CLAIM_OFFICE_SERVER_URL + `getBusinessDate`,
      headers: header,
    });
    return res.body;
  }
  async updateUnderwriterdate(body) {
    let res = await HalApiCaller.patch({
      url: environment.API_SERVER_URL_FINAL + `modifyBusinessDate`,
      headers: this.getHeaders(),
      body: body,
    });
    return res.body;
  }

  async getUnderwriterDate() {
    let res = await HalApiCaller.get({
      url: environment.API_SERVER_URL_FINAL + `getBusinessDate`,
      headers: this.getHeaders(),
    });
    return res.body;
  }

  coveragedecalin(coverage, field: string, value) {
    let amount = 0
    if (coverage[field] != undefined) {
      amount = coverage[field].uwFinalDecision == 'Decline' ? 0 : value
    } else {
      amount = value;
    }
    return amount
  }
  riderdecalin(coverage, rider, field: string, value) {
    let amount = 0
    if (coverage[field] != undefined) {
      amount = coverage[field].uwFinalDecision == 'Decline' ? 0 : value
      if (coverage[field].uwFinalDecision != 'Decline') {
        if (rider[field] != undefined) {
          amount = rider[field].uwFinalDecision == 'Decline' ? 0 : value
        } else {
          amount = value;
        }
      }
    } else {
      amount = value;
    }
    return amount
  }

  loadhelpjson() {
    let languageselected = localStorage.getItem('language')
    switch (languageselected) {
      case 'en':
        this.language = en
        break;
      case 'ar':
        this.language = ar
        break;
      case 'cn':
        break;
      case 'ja':
        break;
      case 'ms':
        break;
      case 'my':
        break;
      case 'pt':
        break;
      case 'th':
        break;
      case 'vi':
        break;
      case 'zh':
        break;
      default:
        this.language = en
    }
    this.updatehelpjson(true)
  }

  // identify which date forment date is coming
  findDateFormet(value) {
    if (value.includes('-')) {
      return value.match(/^(0[1-9]|[12][0-9]|3[01])\-(0[1-9]|1[0-2])\-([12][0-9]{3})$/) && value.match(/^(0[1-9]|1[0-2])\-(0[1-9]|[12][0-9]|3[01])\-([12][0-9]{3})$/) ? 'same' : value.match(/^(0[1-9]|[12][0-9]|3[01])\-(0[1-9]|1[0-2])\-([12][0-9]{3})$/) ? 'dd' : value.match(/^(0[1-9]|1[0-2])\-(0[1-9]|[12][0-9]|3[01])\-([12][0-9]{3})$/) ? 'mm' : value.match(/^([12][0-9]{3})\-(0[1-9]|1[0-2])\-(0[1-9]|[12][0-9]|3[01])$/) ? 'yyyy' : 'InValid';
    } else if (value.includes('/')) {
      return value.match(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([12][0-9]{3})$/) && value.match(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/([12][0-9]{3})$/) ? 'same' : value.match(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([12][0-9]{3})$/) ? 'dd' : value.match(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/([12][0-9]{3})$/) ? 'mm' : value.match(/^([12][0-9]{3})\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/) ? 'yyyy' : 'InValid';
    } else {
      return value.match(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.([12][0-9]{3})$/) && value.match(/^(0[1-9]|1[0-2])\.(0[1-9]|[12][0-9]|3[01])\.([12][0-9]{3})$/) ? 'same' : value.match(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.([12][0-9]{3})$/) ? 'dd' : value.match(/^(0[1-9]|1[0-2])\.(0[1-9]|[12][0-9]|3[01])\.([12][0-9]{3})$/) ? 'mm' : value.match(/^([12][0-9]{3})\.(0[1-9]|1[0-2])\.(0[1-9]|[12][0-9]|3[01])$/) ? 'yyyy' : 'InValid';
    }
  }
  // convert mm/dd/yyyy
  dateformet(value: string) {
    if (value) {
      let datearray
      if (value.search('-') >= 0) {
        datearray = value.split('-');
      } else if (value.search('/') >= 0) {
        datearray = value.split('/');
      } else {
        datearray = value.split('.');
      }

      let dateFormetType = this.findDateFormet(value)

      if (dateFormetType === 'dd') {
        return `${datearray[1]}/${datearray[0]}/${datearray[2]}`
      } else if (dateFormetType === 'mm') {
        return `${datearray[0]}/${datearray[1]}/${datearray[2]}`
      } else if (dateFormetType === 'same') {
        if (this.dateformets === "dd-mm-yyyy" || this.dateformets === "d-m-yyyy" || this.dateformets === "dd/mm/yyyy" || this.dateformets === "d/m/yyyy" || this.dateformets === "d.m.yyyy" || this.dateformets === "dd.mm.yyyy") {
          return `${datearray[1]}/${datearray[0]}/${datearray[2]}`
        } else if (this.dateformets == "mm-dd-yyyy" || this.dateformets == "m-d-yyyy" || this.dateformets == "mm/dd/yyyy" || this.dateformets == "m/d/yyyy" || this.dateformets == "m.d.yyyy" || this.dateformets == "mm.dd.yyyy") {
          return `${datearray[0]}/${datearray[1]}/${datearray[2]}`
        } else {
          return `${datearray[1]}/${datearray[2]}/${datearray[0]}`
        }
      }
      else if (dateFormetType === 'yyyy') {
        return `${datearray[1]}/${datearray[2]}/${datearray[0]}`
      } else {
        return `${datearray[0]}/${datearray[1]}/${datearray[2]}`
      }
    } else { return '' }
  }

  // api date former
  formetdateGetingfromAPI(value){
    if(value && value != null){
    let datearray
      let symbal;
      if (this.dateformets.search('-') >= 0) {
        symbal = '-';
      } else if (this.dateformets.search('/') >= 0) {
        symbal = '/';
      } else {
        symbal = '.';
      }
    if(value.search('-') >= 0){
      datearray=value.split('-');
    }else if(value.search('/') >= 0){
      datearray=value.split('/');
    }else {
      datearray=value.split('.');
    }
     let dateFormetType=this.findDateFormet(value)
     if(dateFormetType === 'same'){
      if(this.dateformets === "dd-mm-yyyy" || this.dateformets === "d-m-yyyy" || this.dateformets === "dd/mm/yyyy" || this.dateformets === "d/m/yyyy" || this.dateformets === "d.m.yyyy"|| this.dateformets === "dd.mm.yyyy"){
        return `${datearray[0]}${symbal}${datearray[1]}${symbal}${datearray[2]}`
      }else if(this.dateformets == "mm-dd-yyyy" || this.dateformets == "m-d-yyyy" || this.dateformets == "mm/dd/yyyy" || this.dateformets == "m/d/yyyy" || this.dateformets == "m.d.yyyy" || this.dateformets == "mm.dd.yyyy"){
        return `${datearray[0]}${symbal}${datearray[1]}${symbal}${datearray[2]}`
      }else{
        return `${datearray[2]}${symbal}${datearray[1]}${symbal}${datearray[0]}`
      }
     }
     else if(dateFormetType === 'dd'){
      if(this.dateformets === "dd-mm-yyyy" || this.dateformets === "d-m-yyyy" || this.dateformets === "dd/mm/yyyy" || this.dateformets === "d/m/yyyy" || this.dateformets === "d.m.yyyy"|| this.dateformets === "dd.mm.yyyy"){
        return `${datearray[0]}${symbal}${datearray[1]}${symbal}${datearray[2]}`
      }else if(this.dateformets == "mm-dd-yyyy" || this.dateformets == "m-d-yyyy" || this.dateformets == "mm/dd/yyyy" || this.dateformets == "m/d/yyyy" || this.dateformets == "m.d.yyyy" || this.dateformets == "mm.dd.yyyy"){
        return `${datearray[1]}${symbal}${datearray[0]}${symbal}${datearray[2]}`
      }else{
        return `${datearray[2]}${symbal}${datearray[1]}${symbal}${datearray[0]}`
      }
    } else if(dateFormetType === 'mm'){
      if(this.dateformets === "dd-mm-yyyy" || this.dateformets === "d-m-yyyy" || this.dateformets === "dd/mm/yyyy" || this.dateformets === "d/m/yyyy" || this.dateformets === "d.m.yyyy"|| this.dateformets === "dd.mm.yyyy"){
        return `${datearray[1]}${symbal}${datearray[0]}${symbal}${datearray[2]}`
      }else if(this.dateformets == "mm-dd-yyyy" || this.dateformets == "m-d-yyyy" || this.dateformets == "mm/dd/yyyy" || this.dateformets == "m/d/yyyy" || this.dateformets == "m.d.yyyy" || this.dateformets == "mm.dd.yyyy"){
        return `${datearray[0]}${symbal}${datearray[1]}${symbal}${datearray[2]}`
      }else{
        return `${datearray[2]}${symbal}${datearray[0]}${symbal}${datearray[1]}`
      }
    }
    else if(dateFormetType === 'yyyy'){
      if(this.dateformets === "dd-mm-yyyy" || this.dateformets === "d-m-yyyy" || this.dateformets === "dd/mm/yyyy" || this.dateformets === "d/m/yyyy" || this.dateformets === "d.m.yyyy"|| this.dateformets === "dd.mm.yyyy"){
        return `${datearray[2]}${symbal}${datearray[1]}${symbal}${datearray[0]}`
      }else if(this.dateformets == "mm-dd-yyyy" || this.dateformets == "m-d-yyyy" || this.dateformets == "mm/dd/yyyy" || this.dateformets == "m/d/yyyy" || this.dateformets == "m.d.yyyy" || this.dateformets == "mm.dd.yyyy"){
        return `${datearray[1]}${symbal}${datearray[2]}${symbal}${datearray[0]}`
      }else{
        return `${datearray[0]}${symbal}${datearray[1]}${symbal}${datearray[2]}`
      }
    }else{
      return `${datearray[0]}${symbal}${datearray[1]}${symbal}${datearray[2]}`
    }
   }else{
      return ''
    }
    }

    // validating the date forment
  datevalidation(value: string){
    if(value && value!=null){
    if(this.dateformets === "dd-mm-yyyy" || this.dateformets === "d-m-yyyy" || this.dateformets === "dd/mm/yyyy" || this.dateformets === "d/m/yyyy" || this.dateformets === "d.m.yyyy"|| this.dateformets === "dd.mm.yyyy"){
      if(this.dateformets.includes('-')){
        return value.match(/^(0[1-9]|[12][0-9]|3[01])\-(0[1-9]|1[0-2])\-([12][0-9]{3})$/)?true:false;
      } else if(this.dateformets.includes('/')){
        return value.match(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([12][0-9]{3})$/)?true:false;
      }else{
        return value.match(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.([12][0-9]{3})$/)?true:false;
      }
    }else if(this.dateformets == "mm-dd-yyyy" || this.dateformets == "m-d-yyyy" || this.dateformets == "mm/dd/yyyy" || this.dateformets == "m/d/yyyy" || this.dateformets == "m.d.yyyy" || this.dateformets == "mm.dd.yyyy"){
      if(this.dateformets.includes('-')){
        return value.match(/^(0[1-9]|1[0-2])\-(0[1-9]|[12][0-9]|3[01])\-([12][0-9]{3})$/)?true:false;
      } else if(this.dateformets.includes('/')){
        return value.match(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/([12][0-9]{3})$/)?true:false;
      }else{
        return value.match(/^(0[1-9]|1[0-2])\.(0[1-9]|[12][0-9]|3[01])\.([12][0-9]{3})$/)?true:false;
      }
    }else{
      if(this.dateformets.includes('-')){
        return value.match(/^([12][0-9]{3})\-(0[1-9]|1[0-2])\-(0[1-9]|[12][0-9]|3[01])$/)?true:false;
      } else if(this.dateformets.includes('/')){
        return value.match(/^([12][0-9]{3})\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/)?true:false;
      }else{
        return value.match(/^([12][0-9]{3})\.(0[1-9]|1[0-2])\.(0[1-9]|[12][0-9]|3[01])$/)?true:false;
      }
    }}else{return true}
  }
}


